import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store/store";
// Custom Imports
import BootstrapVue from "bootstrap-vue";
import VueResource from "vue-resource";
import VeeValidate from "vee-validate";
import VueTinySlider from "vue-tiny-slider";
import vSelect from "vue-select";
import StarRating from "vue-star-rating";
import Vuebar from "vuebar";
import ClickOutside from "vue-click-outside";
import Multiselect from "vue-multiselect";
import Autocomplete from "v-autocomplete";
import Loading from "vue-loading-overlay";
// Fontawesome
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUserSecret,
  faQuestion,
  faInfoCircle,
  faClock,
  faLayerGroup,
  faSearch,
  faArrowRight,
  faEllipsisH,
  faStar,
  faChevronLeft,
  faChevronRight,
  faSlidersH,
  faAngleDown,
  faHeart,
  faPlayCircle,
  faPlay,
  faLock,
  faCheckCircle,
  faUserPlus,
  faUserEdit,
  faUserTimes,
  faChalkboardTeacher,
  faTh,
  faSignOutAlt,
  faBell,
  faCamera,
  faWindowClose,
  faPlus,
  faPlusSquare,
  faTrash,
  faTrashAlt,
  faTimes,
  faBars,
  faHeartBroken,
  faStop,
  faVolumeMute,
  faVolumeUp,
  faExpand,
  faCompress,
  faPhoneSquareAlt,
  faEnvelopeOpen,
  faMapMarkerAlt,
  faShoppingBag,
  faExclamationCircle,
  faEye,
  faSortAmountDown,
  faBroadcastTower,
  faArrowLeft,
  faBook,
    faPause,
    faShareAlt
} from "@fortawesome/free-solid-svg-icons";
import {
  faClock as farClock,
  faEdit as farEdit,
  faFileAlt as farFileAlt
} from "@fortawesome/free-regular-svg-icons";
import {
  faFacebookSquare,
  faInstagram,
  faTwitterSquare,
  faLinkedinIn,
  faFacebookF,
  faTwitter
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// Bootstrap assets
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
//  Custom styles
import "@/assets/fonts/stylesheet.css";
import "@/assets/scss/main.scss";
import "vue-select/dist/vue-select.css";

import "./registerServiceWorker";

Vue.config.productionTip = false;

// Use
Vue.use(BootstrapVue);
Vue.use(VueResource);
Vue.use(VeeValidate, { fieldsBagName: "formFields" });
Vue.use(ClickOutside);
Vue.use(Autocomplete);
Vue.use(Loading);
Vue.component("tiny-slider", VueTinySlider, {
  mouseDrag: true,
  loop: false,
  items: 4,
  gutter: 20,
  swipeAngle: 45,
  controls: true
});
Vue.component("star-rating", StarRating);
Vue.component("multiselect", Multiselect);
library.add(
  faUserSecret,
  faQuestion,
  faInfoCircle,
  faFacebookSquare,
  faInstagram,
  faTwitterSquare,
  faLinkedinIn,
  faClock,
  farClock,
  faLayerGroup,
  faSearch,
  faArrowRight,
  faEllipsisH,
  faStar,
  faChevronLeft,
  faArrowLeft,
  faChevronRight,
  faSlidersH,
  faAngleDown,
  faHeart,
  faPlayCircle,
  faPlay,
  faLock,
  faCheckCircle,
  faUserPlus,
  faUserEdit,
  faUserTimes,
  faChalkboardTeacher,
  faTh,
  faSignOutAlt,
  faBell,
  faCamera,
  farEdit,
  faWindowClose,
  faPlus,
  faPlusSquare,
  faTrash,
  faTrashAlt,
  faTimes,
  faBars,
  faHeartBroken,
  faStop,
  faVolumeMute,
  faVolumeUp,
  faExpand,
  faCompress,
  faPhoneSquareAlt,
  faEnvelopeOpen,
  faMapMarkerAlt,
  faFacebookF,
  faTwitter,
  faShoppingBag,
  faExclamationCircle,
  faEye,
  faSortAmountDown,
  faBroadcastTower,
  farFileAlt,
  faBook,
    faPause,
    faShareAlt
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("v-select", vSelect);
Vue.use(Vuebar);

Vue.config.productionTip = false;

/* http Request response interceptor */
Vue.http.interceptors.push((request, next) => {
  next(response => {
    if (response.status === 401) {
      store.dispatch("user/setLoginStatus", false);
      store.dispatch("user/clearUserData");
      store.dispatch("cart/addToCart", []);
      store.dispatch("teacher/setFollowingTeachers", []);
      if (
        router.currentRoute.matched.some(record => record.meta.requiredAuth)
      ) {
        router.push("/");
      }
    }
  });
});

// Vue app
new Vue({
  router,
  store,
  beforeCreate() {
    this.$store.commit("initialiseStore");
  },
  render: h => h(App)
}).$mount("#app");
